// FitClutch — funil web — textos em norueguês
export default {
  'ageSelect.titleLine1': 'Lag din',
  'ageSelect.titleHighlight': 'Personlige Treningsplan',
  'ageSelect.poweredBy': 'Drevet av FitClutch AI',
  'ageSelect.subtitle': 'Velg aldersgruppen din for å komme i gang',
  'ageSelect.duration': '3-minutters quiz',
  'ageSelect.ageLabel': 'Alder: {range}',
  'ageSelect.footnote': 'Ved å fortsette godtar du våre {terms} og vår {privacy}.',
  'ageSelect.termsLink': 'Bruksvilkår',
  'ageSelect.privacyLink': 'Personvernerklæring',

  'gender.title': 'Hva er kjønnet ditt?',
  'gender.subtitle': 'Vi bruker dette bare for å tilpasse planen din',
  'gender.male': 'Mann',
  'gender.female': 'Kvinne',
  'gender.other': 'Foretrekker å ikke si',

  'socialProof.genderWomen': 'kvinner',
  'socialProof.genderMen': 'menn',
  'socialProof.genderPeople': 'personer',
  'socialProof.decade20': 'i 20-årene',
  'socialProof.decade30': 'i 30-årene',
  'socialProof.decade40': 'i 40-årene',
  'socialProof.decade50': 'i 50-årene eller eldre',
  'socialProof.headlineBig': 'Over {users} {gender}',
  'socialProof.subcopy': '{decade} stoler allerede på FitClutch for å <hl>nå målene sine, tilpasset treningsnivå og tilgjengelig utstyr</hl>. Justerer seg etter hvert som du utvikler deg.',
  'socialProof.subcopyNoDecade': 'stoler allerede på FitClutch for å <hl>nå målene sine, tilpasset treningsnivå og tilgjengelig utstyr</hl>. Justerer seg etter hvert som du utvikler deg.',
  'socialProof.downloadsLabel': 'Nedlastinger',
  'socialProof.cta': 'Fortsett',

  'goal.question': 'Hva er ditt viktigste treningsmål?',
  'goal.option_hipertrofia': 'Bygge muskler',
  'goal.option_emagrecer': 'Gå ned i vekt',
  'goal.option_forca': 'Bli sterkere',
  'goal.option_condicionamento': 'Forbedre generell form',
  'goal.feedbackLead': 'Perfekt:',
  'goal.feedback_hipertrofia': 'skreddersydde styrkeøkter med videoveiledet teknikk i hver repetisjon.',
  'goal.feedback_emagrecer': 'en treningsplan laget for å holde stoffskiftet ditt i gang.',
  'goal.feedback_forca': 'trygg progresjon som gjør deg faktisk sterkere.',
  'goal.feedback_condicionamento': 'balanserte økter som bedrer utholdenhet, mobilitet og energi.',

  'bodyShape.question': 'Hva beskriver kroppen din best i dag?',
  'bodyShape.option_magro_male': 'Slank',
  'bodyShape.option_magro_female': 'Slank',
  'bodyShape.option_magro_neutral': 'Slank kropp',
  'bodyShape.option_cheio_male': 'Fyldigere',
  'bodyShape.option_cheio_female': 'Fyldigere',
  'bodyShape.option_cheio_neutral': 'Fyldigere kropp',
  'bodyShape.option_atletico_male': 'Atletisk',
  'bodyShape.option_atletico_female': 'Atletisk',
  'bodyShape.option_atletico_neutral': 'Atletisk kropp',
  'bodyShape.option_definido_male': 'Veltrent',
  'bodyShape.option_definido_female': 'Veltrent',
  'bodyShape.option_definido_neutral': 'Veltrent kropp',
  'bodyShape.option_medio_male': 'Gjennomsnittlig',
  'bodyShape.option_medio_female': 'Gjennomsnittlig',
  'bodyShape.option_medio_neutral': 'Gjennomsnittlig kropp',

  'bodyGoal.question': 'Hvilken kropp sikter du mot?',
  'bodyGoal.option_definido_male': 'Definert og stram',
  'bodyGoal.option_definido_female': 'Definert og stram',
  'bodyGoal.option_definido_neutral': 'Definert, stram kropp',
  'bodyGoal.option_atletico_male': 'Atletisk og muskuløs',
  'bodyGoal.option_atletico_female': 'Atletisk og i form',
  'bodyGoal.option_atletico_neutral': 'Atletisk, muskuløs kropp',
  'bodyGoal.option_magro_male': 'Slank og lett',
  'bodyGoal.option_magro_female': 'Slank og lett',
  'bodyGoal.option_magro_neutral': 'Slank, lett kropp',
  'bodyGoal.option_curvilineo_male': 'Sterk og kraftig',
  'bodyGoal.option_curvilineo_female': 'Sterk og kurvete',
  'bodyGoal.option_curvilineo_neutral': 'Sterk, definert kropp',

  'lastBest.question': 'Når følte du deg sist i din beste fysiske form?',
  'lastBest.option_agora': 'Akkurat nå',
  'lastBest.option_menos_1_ano': 'Mindre enn et år siden',
  'lastBest.option_1_3_anos': '1–3 år siden',
  'lastBest.option_mais_3_anos': 'Mer enn 3 år siden',
  'lastBest.option_nunca': 'Aldri',

  'weightTrend.question': 'Hvordan endrer vekten din seg vanligvis?',
  'weightTrend.option_estavel': 'Ganske stabil',
  'weightTrend.option_varia': 'Svinger etter vanene mine',
  'weightTrend.option_subindo': 'Har steget jevnt',
  'weightTrend.option_caindo': 'Har sunket jevnt',
  'weightTrend.option_nao_sei': 'Usikker',

  'transformPromo.headline': 'Målet ditt: {target}. Vi viser deg nøyaktig hvordan du kommer dit.',
  'transformPromo.subcopyLead': 'Tren trygt og push grensene dine. FitClutch har',
  'transformPromo.subcopyHighlight1': 'videodemoer fra eksperter',
  'transformPromo.subcopyMid': 'for hver øvelse, som hjelper deg med riktig teknikk og',
  'transformPromo.subcopyHighlight2': 'unngå skader',
  'transformPromo.cta': 'Fortsett',

  'pushUps.question': 'Hvor mange armhevinger klarer du maks på én gang?',
  'pushUps.option_nenhuma': 'Ingen ennå',
  'pushUps.option_1_5': '1-5',
  'pushUps.option_6_15': '6-15',
  'pushUps.option_16_30': '16-30',
  'pushUps.option_30_mais': 'Mer enn 30',

  'squats.question': 'Hvor mange knebøy klarer du i strekk?',
  'squats.option_nenhuma': 'Ingen ennå',
  'squats.option_1_10': '1-10',
  'squats.option_11_25': '11-25',
  'squats.option_26_50': '26-50',
  'squats.option_50_mais': 'Mer enn 50',

  'flexibility.question': 'Hvor bevegelig er du?',
  'flexibility.option_nao_alcanco': 'Når ikke tærne',
  'flexibility.option_quase': 'Når nesten tærne',
  'flexibility.option_facil': 'Når tærne uten problem',
  'flexibility.option_muito_flexivel': 'Veldig bevegelig (spagat, dype tøyninger)',
  'flexibility.option_nao_sei': 'Vet ikke',

  'progressPromo.headline': 'Utgangspunktet ditt er satt. Nå skal vi se det bevege seg.',
  'progressPromo.subcopyLead': 'Hver økt blir',
  'progressPromo.subcopyHighlight': 'registrert automatisk',
  'progressPromo.subcopyTail': '— sanntidsstatistikk som holder deg motivert.',
  'progressPromo.cta': 'Fortsett',

  'focusArea.question': 'Hva er dine målsoner?',
  'focusArea.subtitle': 'Velg en bestemt sone eller "Hele kroppen".',
  'focusArea.option_superior': 'Overkropp',
  'focusArea.option_core': 'Kjerne / Mage',
  'focusArea.option_inferior': 'Underkropp',
  'focusArea.option_corpo_inteiro': 'Hele kroppen',
  'focusArea.cta': 'Fortsett',

  'injuries.question': 'Er det et område som trenger ekstra skånsomhet?',
  'injuries.subtitle': 'Vi tilpasser øvelsene dine for å skåne disse områdene.',
  'injuries.option_ombros': 'Skuldre',
  'injuries.option_joelhos': 'Knær',
  'injuries.option_costas': 'Rygg',
  'injuries.option_nenhuma': 'Ingen',
  'injuries.disclaimer': 'Forebyggende tilpasninger — erstatter ikke medisinsk vurdering.',
  'injuries.cta': 'Fortsett',

  'workoutDuration.question': 'Hva er din ideelle treningslengde?',
  'workoutDuration.option_rapido': 'Rask',
  'workoutDuration.option_rapido_subtitle': '3 øvelser',
  'workoutDuration.option_rapido_badge': 'Opptil 20 min',
  'workoutDuration.option_curto': 'Kort',
  'workoutDuration.option_curto_subtitle': '4-6 øvelser',
  'workoutDuration.option_curto_badge': '20-40 min',
  'workoutDuration.option_medio': 'Middels',
  'workoutDuration.option_medio_subtitle': '5-7 øvelser',
  'workoutDuration.option_medio_badge': '40-60 min',
  'workoutDuration.option_longo': 'Lang',
  'workoutDuration.option_longo_subtitle': '8-10 øvelser',
  'workoutDuration.option_longo_badge': '60+ min',

  'trainingSummaryPromo.headline': '{days}, økter på {duration} — kommer rett opp.',
  'trainingSummaryPromo.subcopyLead': 'Rett fra vårt',
  'trainingSummaryPromo.subcopyHighlight': 'bibliotek med treningsøkter',
  'trainingSummaryPromo.subcopyTail': ', det er alltid en klar for deg.',
  'trainingSummaryPromo.cta': 'Fortsett',
  'trainingSummaryPromo.days_2': '1-2x i uken',
  'trainingSummaryPromo.days_4': '3-4x i uken',
  'trainingSummaryPromo.days_6': '5-6x i uken',
  'trainingSummaryPromo.days_7': 'Hver dag',

  'workSchedule.question': 'Hvordan ser arbeidshverdagen din ut?',
  'workSchedule.option_fixo': 'Kontortid',
  'workSchedule.option_noturno': 'Nattskift',
  'workSchedule.option_flexivel': 'Fleksibel arbeidstid',
  'workSchedule.option_parado': 'Jeg jobber ikke',

  'dailyActivity.question': 'Hvor aktiv er hverdagen din?',
  'dailyActivity.option_sentado': 'Stort sett sittende',
  'dailyActivity.option_ativo': 'Stort sett stående eller i bevegelse',
  'dailyActivity.option_misto': 'Litt av begge deler',
  'dailyActivity.option_nao_sei': 'Usikker',

  'sleepHours.question': 'Hvor mye søvn får du vanligvis?',
  'sleepHours.option_menos_5': 'Mindre enn 5 timer',
  'sleepHours.option_5_6': '5-6 timer',
  'sleepHours.option_7_8': '7-8 timer',
  'sleepHours.option_mais_8': 'Mer enn 8 timer',

  'waterIntake.question': 'Hvor mange glass vann drikker du om dagen?',
  'waterIntake.subtitle': 'Trykk på tallet som ligner mest på rutinen din.',
  'waterIntake.cta': 'Fortsett',

  'profileSummary.headline': 'Her er profilen din',
  'profileSummary.imcLabel': 'KMI - {imc}',
  'profileSummary.imcAbaixo': 'Under',
  'profileSummary.imcNormal': 'Normal',
  'profileSummary.imcAcima': 'Over',
  'profileSummary.imcObeso': 'Fedme',
  'profileSummary.bodyTypeLabel': 'Kroppstype',
  'profileSummary.bodyType_ectomorfo': 'Ektomorf',
  'profileSummary.bodyType_mesomorfo': 'Mesomorf',
  'profileSummary.bodyType_endomorfo': 'Endomorf',
  'profileSummary.lifestyleLabel': 'Livsstil',
  'profileSummary.lifestyle_sedentario': 'Stillesittende',
  'profileSummary.lifestyle_ativo': 'Aktiv',
  'profileSummary.lifestyle_equilibrado': 'Balansert',
  'profileSummary.conditioningLabel': 'Treningsnivå',
  'profileSummary.conditioning_iniciante': 'Grunnleggende',
  'profileSummary.conditioning_intermediario': 'Middels',
  'profileSummary.conditioning_avancado': 'Avansert',
  'profileSummary.conditioning_especialista': 'Ekspert',
  'profileSummary.metabolismLabel': 'Stoffskifte',
  'profileSummary.metabolism_lento': 'Sakte, legger lett på seg',
  'profileSummary.metabolism_acelerado': 'Raskt, går lett ned i vekt',
  'profileSummary.metabolism_equilibrado': 'Balansert',
  'profileSummary.metabolism_variavel': 'Variabelt, avhenger av vaner',
  'profileSummary.cta': 'Fortsett',

  'barriers.question': 'Hva har stoppet deg fra å komme i form før?',
  'barriers.option_motivacao': 'Lite motivasjon',
  'barriers.option_sem_plano': 'Ingen strukturert plan',
  'barriers.option_tempo': 'Tidsmangel',
  'barriers.option_lesoes': 'Fysiske skader',
  'barriers.option_outro': 'Andre grunner',

  'consistencyChart.headline': 'FitClutch hjelper deg å holde ut!',
  'consistencyChart.subcopyLead': 'Den personlige planen din har alt du trenger for å',
  'consistencyChart.subcopyHighlight1': 'holde motivasjonen oppe',
  'consistencyChart.subcopyMid': 'og',
  'consistencyChart.subcopyHighlight2': 'nå kroppen du ønsker',
  'consistencyChart.chartTitle': 'Utviklingen din',
  'consistencyChart.nowLabel': 'Nå',
  'consistencyChart.withLabel': 'Med FitClutch',
  'consistencyChart.withoutLabel': 'Uten FitClutch',
  'consistencyChart.disclaimer': 'Merk: eksemplene er illustrerende. Å holde seg konsekvent med trening og kosthold er det som faktisk gir resultater.',
  'consistencyChart.cta': 'Fortsett',

  'progressLoader.headline': 'Lager din Personlige Treningsplan',
  'progressLoader.item_bodyType': 'Tilpasser til kroppstypen og rutinen din',
  'progressLoader.item_fitnessLevel': 'Vurderer treningsnivået ditt',
  'progressLoader.item_plan': 'Bygger den personlige planen din',
  'progressLoader.testimonial1_title': 'Endret rutinen min',
  'progressLoader.testimonial1_body': 'Endelig en plan som faktisk passer inn i uken min. Lett å følge, og øktene gir mening.',
  'progressLoader.testimonial1_author': 'Renata A.',
  'progressLoader.testimonial2_title': 'Ekte resultater',
  'progressLoader.testimonial2_body': 'På bare noen uker kjente jeg forskjell i energi og styrke. Planen tilpasser seg meg.',
  'progressLoader.testimonial2_author': 'Juliana M.',
  'progressLoader.testimonial3_title': 'En rutine jeg faktisk holder meg til',
  'progressLoader.testimonial3_body': 'Jeg klarte aldri å holde en rutine før FitClutch. Nå er det bare en del av dagen min.',
  'progressLoader.testimonial3_author': 'Carla S.',
  'progressLoader.testimonial4_title': 'Verdt det, helt klart',
  'progressLoader.testimonial4_body': 'Enkelt, rett på sak, og laget rundt kroppen og hverdagen min.',
  'progressLoader.testimonial4_author': 'Fernanda O.',

  'emailCapture.headlineLead': 'Skriv inn e-posten din for å få din',
  'emailCapture.headlineHighlight': 'Personlige Treningsplan',
  'emailCapture.placeholder': 'dinepost@eksempel.com',
  'emailCapture.cta': 'Fortsett',
  'emailCapture.privacyLead': 'Vi respekterer personvernet ditt og beskytter dine personopplysninger, i tråd med vår',
  'emailCapture.privacyLink': 'Personvernerklæring',
};
